import { useMemo } from 'react';
import {
  TimeSignalAnalytic,
  useTimeSignalOefAnalyticsQuery
} from 'graphql/types';
import { useNoteInsightsContext } from 'modules/Insights/Notes/NoteInsightsContextProvider';

export const useGetTimeSignalOefAnalyticsData = (
  labelId: string
): {
  data: TimeSignalAnalytic | undefined;
  loading: boolean;
  isEmpty: boolean;
} => {
  const { currentPeriod } = useNoteInsightsContext();
  const { startDate, endDate } = currentPeriod ?? {};
  const { loading, data } = useTimeSignalOefAnalyticsQuery({
    variables: {
      input: {
        labelId,
        filter: {
          fromDate: startDate,
          toDate: endDate
        }
      }
    }
  });
  return useMemo(
    () => ({
      data: data?.timeSignalOefAnalytics?.items,
      loading,
      isEmpty: data?.timeSignalOefAnalytics?.items.dimensions.length === 0
    }),
    [data, loading]
  );
};
